import React from "react";
import { Helmet } from "react-helmet";
import contentToText from "../../utils/contentToText";
import { isCordovaApp } from "../../utils/cordovaUtils";
import { useBible } from "components/Bible/BibleContainer";
import { useChapter } from "./ChapterContainer";
import { useScriptureRouting } from "components/Bible/useScriptureRouting";

const ChapterMeta = () => {
  const { bibleId } = useScriptureRouting();
  const { getChapter } = useChapter();
  const { biblesById } = useBible();
  const bible = biblesById[bibleId];
  const chapter = getChapter();

  if (isCordovaApp || !bible || !chapter || !chapter.content) return null;

  const description = contentToText(chapter.content, 160);
  const title = `${chapter.reference} - ${bible.name} - ${bible.abbreviation}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="og:title" content={title} />
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content={[
          bible,
          chapter.reference,
          chapter.id,
          bible.name,
          bible.nameLocal,
          bible.abbreviation,
          bible.abbreviationLocal,
          bible.description,
          bible.language?.name,
          bible.language?.id
        ].join(",")}
      />
    </Helmet>
  );
};

export default ChapterMeta;
